// Была проблема с тем, что при переходе на другую страницу, не сбрасывается скролл.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('page:start', () => {
    window.scrollTo(0, 0);
  });
});
